import React from "react";
import {
  Section,
  HeaderSection,
  Title,
  Description,
  FileTypeWarningText,
  UploadList,
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateText,
} from "../primitives";
import FileUploadRow from "../FileUploadRow";

const UploadSection = ({
  uploadFiles,
  uploadedFiles,
  uploadingIds,
  onUpload,
  depositAmount,
  setReloadFiles
}) => {
  return (
    <Section>
      <HeaderSection>
        <Title>Supporting Documents</Title>
        <Description>
          To help us process your re-registration faster, please upload the
          necessary documents as specified.
        </Description>
        <FileTypeWarningText>
          Allowed file types: PDF, JPG/JPEG, or PNG only.
        </FileTypeWarningText>
      </HeaderSection>

      <UploadList>
        {uploadFiles.length > 0 ? (
          uploadFiles.map((fileConfig) => (
            <FileUploadRow
              key={fileConfig.value}
              fileConfig={fileConfig}
              isUploaded={uploadedFiles[fileConfig.value]?.uploaded}
              filePath={uploadedFiles[fileConfig.value]?.filePath}
              fileName={uploadedFiles[fileConfig.value]?.fileName}
              isUploading={uploadingIds.has(fileConfig.value)}
              onUpload={onUpload}
              setReloadFiles={setReloadFiles}
              depositAmount={depositAmount}
            />
          ))
        ) : (
          <EmptyStateContainer>
            <EmptyStateIcon className="fal fa-folder-open" />
            <EmptyStateText>No documents are required at this time.</EmptyStateText>
          </EmptyStateContainer>
        )}
      </UploadList>
    </Section>
  );
};

export default UploadSection;

